var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardVendor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 21.4444V19.5556C28.5 15.9938 28.5 14.213 27.3935 13.1065C26.2871 12 24.5061 12 20.9444 12H19.0556C15.4938 12 13.713 12 12.6065 13.1065C11.5 14.213 11.5 15.9938 11.5 19.5556V21.4444C11.5 25.0061 11.5 26.7871 12.6065 27.8935C13.713 29 15.4938 29 19.0556 29H20.9444C24.5061 29 26.2871 29 27.3935 27.8935C28.5 26.7871 28.5 25.0061 28.5 21.4444Z",
    fill: "white",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8333 18.6112C22.8333 17.0464 21.5648 15.7778 20 15.7778C18.4351 15.7778 17.1666 17.0464 17.1666 18.6112C17.1666 20.176 18.4351 21.4445 20 21.4445C21.5648 21.4445 22.8333 20.176 22.8333 18.6112Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7222 26.1668C24.7222 23.5588 22.6079 21.4446 19.9999 21.4446C17.3919 21.4446 15.2777 23.5588 15.2777 26.1668",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardVendor);
export default __webpack_public_path__ + "static/media/cardVendor.5f3e3ac59c8a9f1d3aa14cfe6b481386.svg";
export { ForwardRef as ReactComponent };